import React from 'react'

import {
  Badge, VerifiedIcon, Icon, Divider,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object } from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

function VerifiedModelTable({ cgtVerification = EMPTY_OBJECT }) {
  function renderAttributes(values) {
    return values.map(({ positive, key }) => (
      <Badge
        type={positive ? 'light-green' : 'light-red'}
        key={key}
      >
        {key}
      </Badge>
    ))
  }

  const { percentage, data } = cgtVerification || {}

  function renderRows() {
    // TODO: handle details here
    const filteredData = data.filter(({ title }) => title !== 'Details')

    return filteredData.map(({ title, values }) => (
      <div
        className="verified-model-table__row"
        key={title}
      >
        <span className="verified-model-table__title cgt-legacy-text-tiny">{title}</span>
        <div className="verified-model-table__badges-container">
          {renderAttributes(values)}
        </div>
      </div>
    ))
  }

  if (!cgtVerification || Object.keys(cgtVerification).length === 0) {
    return null
  }

  return (
    <div className="verified-model-table cgt-effect-card-border-disabled">
      <div className="verified-model-table__header">
        <Icon svgComponent={VerifiedIcon} color="info" className="verified-model-table__icon" />
        <span className="verified-model-table__header-title">Verified model</span>
        <Divider customClass="verified-model-table__divider" />
        <span>{percentage}% passed</span>
      </div>
      {renderRows()}
    </div>
  )
}

VerifiedModelTable.propTypes = {
  cgtVerification: object,
}

export default VerifiedModelTable
